<template>
  <van-list
    class="card_con"
    v-model="Loading"
    :finished="Finished"
    finished-text="没有更多了"
    @load="loadMore"
  >
    <div class="cc-list2" v-for="(item, index) in List" :key="'cc-list2-' + index" @click="LinkCompany(item.exhibitorId)">
      <div class="cc-list2-t">
        <div class="logo">
          <img :src="item.logo" v-if="item.logo" />
          <img src="@assets/img/empty.png" v-else />
        </div>
        <div class="details">
          <p class="comp_name">{{item.compName}}</p>
          <p class="addr"><i class="iconfont icon-dingwei1"></i>{{getAddr(item)}}</p>
        </div>
      </div>
    </div>
  </van-list>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "collect-exhibitor",
  data() {
    return {
      Loading: false, //展商动态加载状态
      Finished: false, //展商加载是否完成状态
      List: [], //展商列表
      pageSize: 12,
      pageIndex: 0,
      totalCount: 0,
      totalPages: 0
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
      userId: "getUserId"
    }),
    option() {
      return {
        exhibitionId: this.exhibitionId,
        userId: this.userId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
    }
  },
  created() {},
  methods: {
    ...mapActions({
      getExhibitorFollower: "follower/getExhibitorFollower",
      LinkCompany:'linkTo/LinkCompany',
    }),
    getAddr(data){ 
      let str=`${data.country? data.country : ''}${data.province? '·' + data.province : ''}${data.city? '·' +  data.city: ''}${data.county? '·' + data.county: ''}`; 
      return str
    },
    async init() {
      this.Loading = true;
      setTimeout(() => {
        this.Loading = false;
      }, 6000);
      const req = {};
      const list = await this.getExhibitorFollower(this.option);
      if (list.code && !list.result) {
        this.Loading = false;
        this.Finished = true;
        return;
      }
      this.List.push(...list.items);
      this.pageSize = list.pageSize;
      this.pageIndex = list.pageIndex;
      this.totalCount = list.totalCount;
      this.totalPages = list.totalPages;
      this.Loading = false;
      if (this.totalCount >= this.List.length) {
        this.Finished = true;
      }
    },
    loadMore() {
      if (this.Finished) return;
      this.pageIndex += 1;
      this.init();
    },
    //tab切换
    tabActive(){
      this.List=[];
      this.pageIndex=1;
      this.Finished=false;
      this.Loading =true;
      this.init();
    },
  }
};
</script>

<style scoped lang="scss">
//展商内容
.card_con {
  padding: 0 0.24rem;
  .cc-list2 {
    padding: 0.2rem;
    margin-bottom: 0.2rem;
    background-color: #1d2435;
    border-radius: 0.05rem;
    color: #fff;
    &-t {
      display: flex;
      .logo {
        position: relative;
        width: 0.88rem;
        height: 0.88rem;
        margin-right: 0.14rem;
        img {
          border-radius: 50%;
          width: 100%;
          height: 100%;
          // object-fit: cover;
        }
      }
      .details {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        padding:0.05rem 0 0.1rem;
        p{
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 1.2;
          &.comp_name {
            font-weight: 400;
          }
          &.addr {
            font-size: 0.2rem;
            .iconfont{
              vertical-align: middle;
              font-size: 0.2rem;
              // position: relative;
              // top: 0.04rem;
              margin-right: 0.06rem;
            }
          }
          
        }
          
          
       
        // .comp_name {
        //   overflow: hidden;
        //   text-overflow: ellipsis;
        //   white-space: nowrap;
        //   line-height: 0.32rem;
        //   height: 0.32rem;
        // }
      }
    }
  }
}
</style>
